import React, { useState, useEffect } from 'react';
import {
  DialogActions,
  DialogContent,
  Divider,
  TextField,
} from '@material-ui/core';
import { loader } from 'graphql.macro';
import { TipoDivergenciaComponent } from '../../../TiposDeDivergencias';
import AjusteDeGradeDoPedidoFinalStep from './AjusteDeGradeDoPedidoFinalStep';
import NovaDivergenciaProgressBar from '../../../components/NovaDivergenciaProgressBar';
import StepperHeader from '../../../components/StepperHeader';
import ContinueOrBackActions from '../../../components/ContinueOrBackActions';
import { useQuery } from '@apollo/client';
import { useParams } from 'react-router-dom';

const gradeQuery = loader('../../../../queries/getTamanhoGradePppOp.gql');

const AjusteDeGradeDoPedido: TipoDivergenciaComponent = ({ onSetStep, onBack }) => {
  const { idProducaoPppOp } = useParams<{ idProducaoPppOp: string }>();

  type itemProducaoPPPOPQuery = {
    grade_1: number;
    grade_2: number;
    grade_3: number;
    grade_4: number;
    grade_5: number;
    grade_6: number;
    grade_7: number;
    grade_8: number;
    grade_9: number;
    grade_10: number;
    grade_11: number;
    grade_12: number;
    grade_13: number;
    grade_14: number;
    Producao_Prog_Prod: {
      tam_1: string;
      tam_2: string;
      tam_3: string;
      tam_4: string;
      tam_5: string;
      tam_6: string;
      tam_7: string;
      tam_8: string;
      tam_9: string;
      tam_10: string;
      tam_11: string;
      tam_12: string;
      tam_13: string;
      tam_14: string;
    };
  };

  const { data } = useQuery<{
    findOneProducao_PPP_OP: itemProducaoPPPOPQuery;
  }>(gradeQuery, {
    variables: {
      idProducaoPppOp: parseInt(idProducaoPppOp, 10),
    },
  });

  const [valoresGrade, setValoresGrade] = useState<Record<string, number>>({});
  const [nomeTecido, setNomeTecido] = useState('');

  const dadosOP = data?.findOneProducao_PPP_OP;
  const dadosTamanhos = dadosOP?.Producao_Prog_Prod;

  useEffect(() => {
    if (dadosOP && dadosTamanhos) {
      const gradeInicial: Record<string, number> = {};
      for (let i = 1; i <= 14; i++) {
        const tamanho = dadosTamanhos[`tam_${i}` as keyof typeof dadosTamanhos];
        const grade = dadosOP[`grade_${i}` as keyof typeof dadosOP] as number;

        if (tamanho !== null && tamanho !== undefined && tamanho !== '') {
          gradeInicial[tamanho] = grade ?? 0;
        }
      }
      setValoresGrade(gradeInicial);
    }
  }, [data, dadosOP, dadosTamanhos]);

  const handleAlterarGrade = (tamanho: string, valor: string) => {
    setValoresGrade((anterior) => ({
      ...anterior,
      [tamanho]: Number(valor),
    }));
  };

  const handleContinue = () => {
    const nextPayload = {
      valoresGrade: valoresGrade,
      nomeTecido: nomeTecido,
    };
    onSetStep({
      component: AjusteDeGradeDoPedidoFinalStep as TipoDivergenciaComponent,
      payload: nextPayload,
    });
  };

  const stepNumber = '2';
  const stepTitle = 'Faça o ajuste de grade do pedido';
  const indices = Array.from({ length: 14 }, (_, i) => i + 1);

  return (
    <React.Fragment>
      <NovaDivergenciaProgressBar value={66}></NovaDivergenciaProgressBar>
      <DialogContent
        className='backgroundNeutral50 minHeightDivergenciaModalContent divergenciaMaxWidth'
        style={{ padding: '0 32px' }}
      >
        <StepperHeader
          stepNumber={stepNumber}
          stepSubTitle={''}
          stepTitle={stepTitle}
        ></StepperHeader>
        <div className='px16'>
          <form
            autoComplete='off'
            noValidate
            onSubmit={(e) => {
              e.preventDefault();
              handleContinue();
            }}
          >
            <div style={{ marginBottom: '24px', marginTop: '16px' }}>
              <TextField
                fullWidth
                label="Nome do tecido ou referência da grade"
                variant="outlined"
                value={nomeTecido}
                onChange={(e) => setNomeTecido(e.target.value)}
                placeholder="Ex: Malha Algodão Egípcio, Viscose, etc..."
              />
            </div>

            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '16px' }}>
              {indices.map((i) => {
                const tamanho = dadosTamanhos?.[`tam_${i}` as keyof typeof dadosTamanhos];
                if (!tamanho) return null;

                return (
                  <TextField
                    key={tamanho}
                    label={`Tam. ${tamanho}`}
                    type='number'
                    variant='outlined'
                    inputProps={{ min: 0 }}
                    style={{ width: '100px' }}
                    value={valoresGrade[tamanho] ?? 0}
                    onChange={(e) => handleAlterarGrade(tamanho, e.target.value)}
                  />
                );
              })}
            </div>
          </form>
        </div>
      </DialogContent>
      <Divider></Divider>
      <DialogActions className='divergenciaMaxWidth' style={{ padding: '30px 32px' }}>
        <ContinueOrBackActions
          continueMessage='Continuar'
          disabled={!nomeTecido.trim()}
          disabledMessage='Informe o tecido para continuar'
          onBack={onBack}
          onContinue={handleContinue}
        />
      </DialogActions>
    </React.Fragment>
  );
};

export default AjusteDeGradeDoPedido;